import { useState } from "react"
import { TabNav } from "./TabNav"
import { TabPane } from "./TabPanel"

type Props = {
    items: { [key: string]: JSX.Element | undefined }
}

export function NftTabs({ items }: Props) {
    const [tab, setTab] = useState<string>(Object.keys(items)[0])

    return <div>
        <ul className="nav nav-tabs flex items-center" role="tablist">
            {
                Object.keys(items).map(label => <TabNav onClick={label => setTab(label)} active={label === tab} label={label} key={label} />)
            }
        </ul>

        <div className="tab-content">
            {
                Object.keys(items).map(label => <TabPane key={label} active={label === tab} > {items[label]} </TabPane>)
            }
        </div>
    </div>
}